import React from "react";
import PropTypes from "prop-types";
import { StyledDiv, StyledAnchor } from "./_.styles";

import { Icon } from "@ebscois/react-component-library";

const OtherLanguagesSelector = ({
  children,
  isOpen,
  label,
  onClick,
  onBlur,
}) => {
  return (
    <StyledDiv data-element="navigation-list-item" onClick={onClick}>
      <StyledAnchor
        onBlur={onBlur}
        data-element="navigation-anchor"
        aria-expanded={isOpen}
        aria-haspopup={true}
      >
        {label}
        <Icon
          icon={{
            glyph: isOpen ? "keyboard_arrow_up" : "keyboard_arrow_down",
            color: "gray800",
          }}
        />
      </StyledAnchor>
      {children}
    </StyledDiv>
  );
};

OtherLanguagesSelector.displayName = "OtherLanguesItem";

OtherLanguagesSelector.propTypes = {
  /**
   * The contents of the item, typically a Navigation Dropdown instance
   */
  children: PropTypes.node,
  /**
   * Text that will displayed by the Navigation Item
   */
  linkText: PropTypes.string,
  /**
   * Optional: toggle state for the submenu
   */
  isOpen: PropTypes.bool,
  /**
   * On click action
   */
  onClick: PropTypes.func,
  /**
   * On blur action
   */
  onBlur: PropTypes.func,
};

OtherLanguagesSelector.defaultProps = {
  isOpen: false,
};

export default OtherLanguagesSelector;
